// assets
import { IconDashboard, IconRobot } from "@tabler/icons";

// constant
const icons = { IconDashboard, IconRobot };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
  id: "dashboard",
  title: "Dashboard",
  type: "group",
  children: [
    {
      id: "default",
      title: "Dashboard",
      type: "item",
      url: "/dashboard/default",
      icon: icons.IconDashboard,
      breadcrumbs: false,
    },
    {
      id: "taiworkforce",
      title: "Tai Workforce",
      type: "item",
      url: "/dashboard/taiworkforce",
      icon: icons.IconRobot,
      breadcrumbs: false,
    },
  ],
};

export default dashboard;
